import CustomReasonsPanel from './customReasonsPanel.container';

export default CustomReasonsPanel